import { Footer } from '@/components/common/Footer';
import { Logo } from '@/components/common/Logo';
import { useMarque } from '@/hooks/useMarque';
import React from 'react';
import { LanguageToggle } from './LanguageToggle';

interface AuthLayoutProps {
  children: React.ReactNode;
  title: string;
  subtitle?: string;
}

export const AuthLayout: React.FC<AuthLayoutProps> = ({
  children,
  title,
  subtitle,
}) => {
  // [C2 — marque blanche] C'est l'écran de la scène visée : une dirigeante
  // ouvre le lien de son cabinet et la page porte SON nom, avant toute
  // connexion. Sans marque de cabinet, rien ne change — l'écran maison reste
  // exactement ce qu'il était.
  const marque = useMarque();

  return (
    <div
      className={
        marque.parDefaut
          ? 'from-primary-50 to-brand-50 relative min-h-screen bg-gradient-to-br via-white'
          : 'relative min-h-screen'
      }
      style={
        marque.parDefaut ? undefined : { backgroundColor: 'var(--marque-fond)' }
      }
    >
      {/* Language Toggle - Position absolue en haut à droite */}
      <div className="absolute top-4 right-4 z-10 bg-white/15 p-2">
        <LanguageToggle />
      </div>

      <div className="flex min-h-screen justify-center">
        {/* Left side - Form */}
        <div className="flex flex-1 flex-col justify-center px-4 py-8 sm:px-6 sm:py-12 lg:w-1/2 lg:flex-none lg:px-8">
          <div className="mx-auto w-full max-w-md">
            {/* Logo — celui du cabinet quand il y en a un, sinon le nôtre */}
            <div className="mb-0 text-center">
              {marque.parDefaut ? (
                <Logo height={120} width={120} className="justify-center" />
              ) : marque.logoUrl ? (
                <img
                  src={marque.logoUrl}
                  alt={marque.nomAffiche}
                  className="mx-auto h-[120px] w-auto object-contain"
                />
              ) : (
                <p
                  className="py-10 text-2xl font-bold"
                  style={{ color: 'var(--marque-accent)' }}
                >
                  {marque.nomAffiche}
                </p>
              )}
            </div>

            {/* Header */}
            <div className="mb-6 text-center sm:mb-8">
              <h1 className="text-3xl font-bold tracking-tight text-neutral-900">
                {title}
              </h1>
              {subtitle && <p className="mt-2 text-neutral-600">{subtitle}</p>}
            </div>

            {/* Form */}
            <div className="shadow-soft rounded-2xl border border-neutral-200 bg-white p-6 sm:p-8">
              {children}
            </div>

            {/* Footer */}
            {marque.parDefaut ? (
              <Footer variant="auth" />
            ) : (
              <p
                className="mt-6 text-center text-xs"
                style={{ color: 'var(--marque-encre-douce)' }}
              >
                {marque.piedDePage ?? marque.nomAffiche}
              </p>
            )}
          </div>
        </div>

        {/* Right side - Image/Illustration */}
        {/* <div className="lg:from-brand-500 lg:to-brand-700 hidden lg:flex lg:flex-1 lg:items-center lg:justify-center lg:bg-gradient-to-br">
          <div className="max-w-md text-center text-white">
            <div className="mb-8">
              <div className="mx-auto h-24 w-24 animate-pulse rounded-full bg-white/20 p-6">
                <div className="h-full w-full animate-spin rounded-full bg-white/30"></div>
              </div>
            </div>
            <h3 className="mb-4 text-2xl font-bold">Automatisation OpenPaye</h3>
            <p className="text-brand-100 text-lg leading-relaxed">
              {t('landing.testimonial')}
            </p>
            <div className="mt-8 flex items-center justify-center gap-2">
              <div className="h-2 w-2 rounded-full bg-white"></div>
              <div className="h-2 w-8 rounded-full bg-white/60"></div>
              <div className="h-2 w-2 rounded-full bg-white/40"></div>
            </div>
          </div>
        </div> */}
      </div>
    </div>
  );
};
